import React from "react";

/**
 * GIGLife26 logo — uses the founder's custom artwork (JPEG in /brand).
 * Sizes match the previous SVG/text logo so layout stays unchanged.
 */
export const Logo = ({ size = "md", className = "" }) => {
  const heights = {
    sm: "h-10",                          // ~40px
    md: "h-12",                          // ~48px (+0% baseline)
    lg: "h-32 sm:h-40",                  // +70% from h-20/h-24
    xl: "h-40 sm:h-56 lg:h-72",          // +70% from h-24/h-32/h-40
  };
  const cls = heights[size] || heights.md;
  return (
    <img
      src={`${process.env.PUBLIC_URL || ""}/brand/giglife26-logo.jpg`}
      alt="GIGLife26"
      data-testid="app-logo"
      className={`${cls} w-auto select-none ${className}`}
      draggable={false}
    />
  );
};

export default Logo;
